var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3306.9 2999.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1005"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1896.9,1127.5c28.2,0,51.1,22.9,51.1,51.1s-22.9,51.1-51.1,51.1-51.1-22.9-51.1-51.1,22.9-51.1,51.1-51.1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1009"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1896.9,1331.8c28.2,0,51.1,22.9,51.1,51.1s-22.9,51.1-51.1,51.1-51.1-22.9-51.1-51.1,22.9-51.1,51.1-51.1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1013"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1896.9,1536c28.2,0,51.1,22.9,51.1,51.1s-22.9,51.1-51.1,51.1-51.1-22.9-51.1-51.1,22.9-51.1,51.1-51.1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1017"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2203.2,1995.5H875.8c-84.5,0-153.2-68.7-153.2-153.2v-868c0-84.5,68.7-153.2,153.2-153.2h1327.5c84.5,0,153.2,68.7,153.2,153.2v868c0,84.5-68.7,153.2-153.2,153.2ZM875.8,923.3c-28.2,0-51.1,22.9-51.1,51.1v868c0,28.2,22.9,51.1,51.1,51.1h1327.5c28.2,0,51.1-22.9,51.1-51.1v-868c0-28.2-22.9-51.1-51.1-51.1H875.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1021"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2509.6,1689.2h-204.2c-28.2,0-51.1-22.9-51.1-51.1s22.9-51.1,51.1-51.1h204.2c28.2,0,51.1,22.9,51.1,51.1s-22.9,51.1-51.1,51.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1025"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2509.6,1229.7h-204.2c-28.2,0-51.1-22.9-51.1-51.1s22.9-51.1,51.1-51.1h204.2c28.2,0,51.1,22.9,51.1,51.1s-22.9,51.1-51.1,51.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1029"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1233.2,923.3c-28.2,0-51.1-22.9-51.1-51.1v-204.2c0-112.6,91.6-204.2,204.2-204.2h765.8c28.2,0,51.1,22.9,51.1,51.1s-22.9,51.1-51.1,51.1h-765.8c-56.3,0-102.1,45.8-102.1,102.1v204.2c0,28.2-22.9,51.1-51.1,51.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1033"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1845.8,923.3c-28.2,0-51.1-22.9-51.1-51.1v-357.4c0-28.2,22.9-51.1,51.1-51.1s51.1,22.9,51.1,51.1v357.4c0,28.2-22.9,51.1-51.1,51.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path1035"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1692.7,1638.1h-612.7c-28.2,0-51.1-22.9-51.1-51.1v-408.4c0-28.2,22.9-51.1,51.1-51.1h612.7c28.2,0,51.1,22.9,51.1,51.1v408.4c0,28.2-22.9,51.1-51.1,51.1ZM1131.1,1536h510.6v-306.3h-510.6v306.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1039"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1782.7,2301.8h-90.1c-28.2,0-51.1-22.9-51.1-51.1s22.9-51.1,51.1-51.1h90.1c19.5,0,37-10.8,45.7-28.2l124.9-249.9c12.6-25.2,43.3-35.4,68.5-22.8,25.2,12.6,35.4,43.3,22.8,68.5l-124.9,249.9c-26.1,52.2-78.6,84.7-137,84.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1043"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1386.3,2301.8h-90.1c-58.4,0-110.9-32.5-137-84.7l-124.9-249.9c-12.6-25.2-2.4-55.9,22.8-68.5,25.2-12.6,55.9-2.4,68.5,22.8l124.9,249.9c8.7,17.4,26.2,28.2,45.7,28.2h90.1c28.2,0,51.1,22.9,51.1,51.1s-22.9,51.1-51.1,51.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path1045"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1692.7,2761.3h-306.3c-28.2,0-51.1-22.9-51.1-51.1v-459.5c0-28.2,22.9-51.1,51.1-51.1h306.3c28.2,0,51.1,22.9,51.1,51.1v459.5c0,28.2-22.9,51.1-51.1,51.1ZM1437.4,2659.2h204.2v-357.4h-204.2v357.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1049"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2458.5,719.1h-153.2c-112.6,0-204.2-91.6-204.2-204.2s21.2-105.8,59.8-144.4c38.6-38.6,89.9-59.8,144.4-59.8h153.2c112.6,0,204.2,91.6,204.2,204.2s-21.2,105.8-59.8,144.4c-38.6,38.6-89.9,59.8-144.4,59.8ZM2305.3,412.8c-27.3,0-52.9,10.6-72.2,29.9-19.3,19.3-29.9,44.9-29.9,72.2,0,56.3,45.8,102.1,102.1,102.1h153.2c27.3,0,52.9-10.6,72.2-29.9,19.3-19.3,29.9-44.9,29.9-72.2,0-56.3-45.8-102.1-102.1-102.1h-153.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1053"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M773.7,1076.5h-337c-28.2,0-51.1-22.9-51.1-51.1s22.9-51.1,51.1-51.1h337c28.2,0,51.1,22.9,51.1,51.1s-22.9,51.1-51.1,51.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1057"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M773.7,1382.8h-337c-28.2,0-51.1-22.9-51.1-51.1s22.9-51.1,51.1-51.1h337c28.2,0,51.1,22.9,51.1,51.1s-22.9,51.1-51.1,51.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1061"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M436.7,1536c-28.2,0-51.1-22.9-51.1-51.1v-612.7c0-28.2,22.9-51.1,51.1-51.1s51.1,22.9,51.1,51.1v612.7c0,28.2-22.9,51.1-51.1,51.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1065"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2999.7,1382.8c0,28.2-22.9,51.1-51.1,51.1s-51.1-22.9-51.1-51.1,22.9-51.1,51.1-51.1,51.1,22.9,51.1,51.1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1069"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2948.7,1995.5c-5.7,0-11.3-.9-16.8-2.8l-439.1-153.2c-20.5-7.2-34.2-26.5-34.2-48.2v-765.8c0-21.7,13.7-41.1,34.2-48.2l439.1-153.2c15.6-5.4,32.9-3,46.4,6.6,13.5,9.6,21.5,25.1,21.5,41.6v280.8c0,28.2-22.9,51.1-51.1,51.1s-51.1-22.9-51.1-51.1v-208.9l-337,117.5v693.3l337,117.5v-260c0-28.2,22.9-51.1,51.1-51.1s51.1,22.9,51.1,51.1v331.9c0,16.5-8,32-21.5,41.6-8.8,6.2-19.1,9.4-29.6,9.4Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsIcon);
export default __webpack_public_path__ + "static/media/news-icon.dce47eb08304ed8b0985baf2f0a00756.svg";
export { ForwardRef as ReactComponent };